class Multicast {
  constructor() {
    this.multicast = true
    this.init = false
    this.player = null
    this.timeout = null
    this.channelList = []
    this.lastState = null
  }
  async _init() {
    if (this.init) return true

    _$.loader.createPlayer("object", {
      id: "videoBroadcast",
      type: "video/broadcast",
      style: "position: absolute; left:0; top:0; right:0; bottom:0; width:100%; height:100%;"
    })

    this.player = document.getElementById("videoBroadcast")

    this.player.addEventListener("PlayStateChange", this._playerListener)

    _$.vue.$on("fetch.channels", async () => {
      await __._api.execute(`SCURL ${__.platform.baseUrl}/api/vestel/channels`)
      __._api.execute("UCL")
      __._api.execute("UCL")

      const config = this.player.getChannelConfig()
      if (config.channelList.length) this.channelList = config.channelList
    })

    _$.vue.$emit("fetch.channels", true)

    this.init = true
    return true
  }

  async start() {
    document.getElementById("videoMp4").style.display = "none"
    document.getElementById("videoBroadcast").style.display = null

    __.common._tvWindowSetSize()
    this.lastState = null

    return true
  }
  async destroy() {
    this.stop()
    document.getElementById("videoBroadcast").style.display = "none"

    return true
  }
  async play(source) {
    this.lastState = null

    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    const channel = Array.from(__._multicast.channelList).find(rec => rec.name === source.replace(/[:/=;/.a-zA-Z]/g, ""))

    this.player.setChannel(channel, true)

    return promise.done
  }
  async stop() {
    this.lastState = null

    const promise = await _$.progress.create()

    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.stop()

    return promise.done
  }
  async pause() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPaused", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.play(0)

    return promise.done
  }
  async continue() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.play(1)

    return promise.done
  }

  /* Control Helpers */
  async isSeekable() {
    return this.player.playTime
  }
  async getDuration() {
    return this.player.playTime
  }
  async getPosition() {
    return this.player.playPosition
  }
  async setPosition(position) {
    return this.player.seek(position * 1000)
  }

  /* Language and Subtitles Helpers */
  async getSubtitles() {
    const type = this.player.COMPONENT_TYPE_SUBTITLE
    let subtitles = this.player.getComponents(type)
    let current = Array.from(this.player.getCurrentActiveComponents(type)).shift() || {}

    if (!subtitles.length) return false
    subtitles = Array.from(subtitles)
    subtitles = subtitles.map(subtitle => {
      return { key: subtitle.pid, value: subtitle.language, selected: subtitle.pid === current.pid }
    })

    if (subtitles.length <= 1) return false
    return subtitles
  }
  async setSubtitle(pid) {
    const type = this.player.COMPONENT_TYPE_SUBTITLE
    let subtitles = this.player.getComponents(type)
    if (!subtitles.length) return false

    subtitles = Array.from(subtitles)

    const component = subtitles.find(rec => rec.pid == pid)
    if (!component) return false

    let current = Array.from(this.player.getCurrentActiveComponents(type)).shift()
    if (current) this.player.unselectComponent(current)

    this.player.selectComponent(component)

    return true
  }
  async closeSubtitle() {
    const self = this
    const type = this.player.COMPONENT_TYPE_SUBTITLE
    let subtitles = this.player.getComponents(type)
    if (!subtitles.length) return false

    subtitles = Array.from(subtitles)
    subtitles.map(subtitle => self.player.unselectComponent(subtitle))
    return true
  }

  async getLanguages() {
    const type = this.player.COMPONENT_TYPE_AUDIO
    let audios = this.player.getComponents(type)
    let current = Array.from(this.player.getCurrentActiveComponents(type)).shift()

    if (!audios.length) return false
    audios = Array.from(audios)
    audios = audios.map(audio => {
      return { key: audio.pid, value: audio.language, selected: audio.pid === current.pid }
    })

    if (audios.length <= 1) return false
    return audios
  }
  async setLanguage(pid) {
    const type = this.player.COMPONENT_TYPE_AUDIO
    let audios = this.player.getComponents(type)
    if (!audios.length) return false

    audios = Array.from(audios)

    const component = audios.find(rec => rec.pid == pid)
    if (!component) return false

    let current = Array.from(this.player.getCurrentActiveComponents(type)).shift()
    if (current) this.player.unselectComponent(current)

    this.player.selectComponent(component)

    let audio = Array.from(this.player.getCurrentActiveComponents(this.player.COMPONENT_TYPE_SUBTITLE)).shift()
    if (audio) this.player.unselectComponent(audio)

    return true
  }

  async _playerListener(event) {
    let state = null
    switch (event.state) {
      case 0:
        state = "error"
        break
      case 1:
        state = "start"
        break
      case 2:
        state = "play"
        break
      default:
        state = "error"
        break
    }
    if (!state || (this.lastState === 2 && !event.state)) return false

    if (this.timeout) this.timeout = window.clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => _$.handler.emit("media_event", state), 1000)
    this.lastState = event.state

    return true
  }
}

export default Multicast
